import FindPasswordResultContainer from './FindPasswordResultContainer';
export default FindPasswordResultContainer;
